/**
 * COMPLETE Position to Form Mapping - AUTO-GENERATED
 * Generated from CSV: 'Job Positions-Jobs with Form and Links copy.csv'
 * Total Positions: 157
 *
 * Distribution:
 * - CREATIVE: 24 positions
 * - TECH: 20 positions
 * - HR_OPERATIONS: 19 positions
 * - POST_PRODUCTION: 18 positions
 * - ACCOUNT_MANAGEMENT: 15 positions
 * - DIGITAL: 15 positions
 * - PRODUCTION: 12 positions
 * - VIDEO_PHOTO: 10 positions
 * - SOCIAL_MEDIA: 10 positions
 * - TECH_LEADERSHIP: 8 positions
 * - FINANCE: 6 positions
 */

// Form Type Constants
export const FORM_TYPES = {
  TECH: 'TECH',
  TECH_LEADERSHIP: 'TECH_LEADERSHIP',
  CREATIVE: 'CREATIVE',
  VIDEO_PHOTO: 'VIDEO_PHOTO',
  POST_PRODUCTION: 'POST_PRODUCTION',
  SOCIAL_MEDIA: 'SOCIAL_MEDIA',
  ACCOUNT_MANAGEMENT: 'ACCOUNT_MANAGEMENT',
  PRODUCTION: 'PRODUCTION',
  HR_OPERATIONS: 'HR_OPERATIONS',
  DIGITAL: 'DIGITAL',
  FINANCE: 'FINANCE'
};

// Form Type to Airtable Page ID mapping
export const FORM_TYPE_TO_PAGE_ID = {
  [FORM_TYPES.TECH]: 'pagysJOea57Lcl1Fb',
  [FORM_TYPES.TECH_LEADERSHIP]: 'pagsL2BDIpGCBAU36',
  [FORM_TYPES.CREATIVE]: 'pagMyCFGOv0nmA2w4',
  [FORM_TYPES.VIDEO_PHOTO]: 'pagFoHqpQoGQa0eql',
  [FORM_TYPES.POST_PRODUCTION]: 'pagg2fy8v53X4BeNe',
  [FORM_TYPES.SOCIAL_MEDIA]: 'pagv51R17SEmO3KDO',
  [FORM_TYPES.ACCOUNT_MANAGEMENT]: 'pagJRtMOJZ5hWuMSq',
  [FORM_TYPES.PRODUCTION]: 'paglZEkkgTA3thvTB',
  [FORM_TYPES.HR_OPERATIONS]: 'pagR9N12Zy8XIcaBv',
  [FORM_TYPES.DIGITAL]: 'pagQ9NjptujXtXTtR',
  [FORM_TYPES.FINANCE]: 'pagCCLZi0TfdX1bEi'
};

// COMPLETE Position to Form Type mapping (157 positions → 11 form types)
export const POSITION_FORM_MAPPING = {
  "3D Artist": FORM_TYPES.POST_PRODUCTION,
  "3D Artist - Junior": FORM_TYPES.POST_PRODUCTION,
  "3D Artist - Senior": FORM_TYPES.POST_PRODUCTION,
  "Account Director": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Account Director - Business Growth": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Account Director - Influencers": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Account Executive": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Account Executive - Business Growth": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Account Executive - Influencers": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Account Manager": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Account Manager - Business Growth": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Account Manager - Business Growth - Senior": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Account Manager - Influencers": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Account Manager - Senior": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Accountant": FORM_TYPES.FINANCE,
  "Accountant - Junior": FORM_TYPES.FINANCE,
  "Accountant - Senior": FORM_TYPES.FINANCE,
  "Administrative Assistant": FORM_TYPES.HR_OPERATIONS,
  "AI Engineer": FORM_TYPES.TECH,
  "Animator": FORM_TYPES.POST_PRODUCTION,
  "Animator - Junior": FORM_TYPES.POST_PRODUCTION,
  "Animator - Senior": FORM_TYPES.POST_PRODUCTION,
  "Art Director": FORM_TYPES.CREATIVE,
  "Art Director - Ai": FORM_TYPES.CREATIVE,
  "Art Director - Junior": FORM_TYPES.CREATIVE,
  "Art Director - Senior": FORM_TYPES.CREATIVE,
  "Assistant Photographer": FORM_TYPES.VIDEO_PHOTO,
  "Associate Creative Director": FORM_TYPES.CREATIVE,
  "Branding Art Director": FORM_TYPES.CREATIVE,
  "CEO": FORM_TYPES.HR_OPERATIONS,
  "Colorist": FORM_TYPES.POST_PRODUCTION,
  "Colorist - Junior": FORM_TYPES.POST_PRODUCTION,
  "Colorist - Senior": FORM_TYPES.POST_PRODUCTION,
  "Community Manager": FORM_TYPES.DIGITAL,
  "Community Manager - Junior": FORM_TYPES.DIGITAL,
  "Community Manager - Senior": FORM_TYPES.DIGITAL,
  "Content Creator": FORM_TYPES.SOCIAL_MEDIA,
  "Content Creator - Junior": FORM_TYPES.SOCIAL_MEDIA,
  "Content Creator - Senior": FORM_TYPES.SOCIAL_MEDIA,
  "Creative Copywriter - Arabic": FORM_TYPES.CREATIVE,
  "Creative Copywriter - Arabic - Junior": FORM_TYPES.CREATIVE,
  "Creative Copywriter - Arabic - Senior": FORM_TYPES.CREATIVE,
  "Creative Copywriter - English": FORM_TYPES.CREATIVE,
  "Creative Copywriter - English - Junior": FORM_TYPES.CREATIVE,
  "Creative Copywriter - English - Senior": FORM_TYPES.CREATIVE,
  "Creative Director": FORM_TYPES.CREATIVE,
  "CTO": FORM_TYPES.TECH_LEADERSHIP,
  "Developer - Backend - Junior": FORM_TYPES.TECH,
  "Developer - Backend - Laravel": FORM_TYPES.TECH,
  "Developer - Backend - Laravel/Python": FORM_TYPES.TECH,
  "Developer - Backend - Python": FORM_TYPES.TECH,
  "Developer - Backend - Senior": FORM_TYPES.TECH,
  "Developer - Frontend": FORM_TYPES.TECH,
  "Developer - Frontend - Junior": FORM_TYPES.TECH,
  "Developer - Frontend - Senior": FORM_TYPES.TECH,
  "Developer - Full Stack": FORM_TYPES.TECH,
  "Developer - Full Stack - Junior": FORM_TYPES.TECH,
  "Developer - Full Stack - Senior": FORM_TYPES.TECH,
  "Developer - Wordpress": FORM_TYPES.TECH,
  "Developer - Wordpress - Junior": FORM_TYPES.TECH,
  "Developer - Wordpress - Senior": FORM_TYPES.TECH,
  "DevOps": FORM_TYPES.TECH_LEADERSHIP,
  "Digital Marketing Director": FORM_TYPES.DIGITAL,
  "Digital Marketing Manager": FORM_TYPES.DIGITAL,
  "Digital Marketing Manager - Senior": FORM_TYPES.DIGITAL,
  "Digital Marketing Specialist": FORM_TYPES.DIGITAL,
  "Director of Recruitment": FORM_TYPES.HR_OPERATIONS,
  "Driver": FORM_TYPES.HR_OPERATIONS,
  "Editor": FORM_TYPES.POST_PRODUCTION,
  "Editor - Junior": FORM_TYPES.POST_PRODUCTION,
  "Editor - Senior": FORM_TYPES.POST_PRODUCTION,
  "Executive Assistant": FORM_TYPES.HR_OPERATIONS,
  "Executive Assistant - SL": FORM_TYPES.HR_OPERATIONS,
  "Finance Director": FORM_TYPES.FINANCE,
  "Financial Controller": FORM_TYPES.FINANCE,
  "Graphic Designer": FORM_TYPES.CREATIVE,
  "Graphic Designer - Junior": FORM_TYPES.CREATIVE,
  "Graphic Designer - Senior": FORM_TYPES.CREATIVE,
  "Hair Stylist": FORM_TYPES.PRODUCTION,
  "Head of Accounts": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Head of Content": FORM_TYPES.PRODUCTION,
  "Head of Digital": FORM_TYPES.DIGITAL,
  "Head of Government Services": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Head of Investment": FORM_TYPES.FINANCE,
  "Head of Luxury Services": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Head of Operation": FORM_TYPES.HR_OPERATIONS,
  "Head of Production": FORM_TYPES.PRODUCTION,
  "Head of Social Media": FORM_TYPES.SOCIAL_MEDIA,
  "Head of UX": FORM_TYPES.TECH_LEADERSHIP,
  "HR Coordinator": FORM_TYPES.HR_OPERATIONS,
  "HR Coordinator - Junior": FORM_TYPES.HR_OPERATIONS,
  "HR Coordinator - Senior": FORM_TYPES.HR_OPERATIONS,
  "HR Manager": FORM_TYPES.HR_OPERATIONS,
  "Illustrator": FORM_TYPES.CREATIVE,
  "Illustrator - Junior": FORM_TYPES.CREATIVE,
  "Illustrator - Senior": FORM_TYPES.CREATIVE,
  "Industrial Designer": FORM_TYPES.CREATIVE,
  "Industrial Designer - Junior": FORM_TYPES.CREATIVE,
  "Industrial Designer - Senior": FORM_TYPES.CREATIVE,
  "Influencer": FORM_TYPES.SOCIAL_MEDIA,
  "IT Manager": FORM_TYPES.TECH_LEADERSHIP,
  "Learning and Development Director": FORM_TYPES.HR_OPERATIONS,
  "Makeup Artist": FORM_TYPES.PRODUCTION,
  "Marketing Manager": FORM_TYPES.DIGITAL,
  "Motion Designer": FORM_TYPES.CREATIVE,
  "Operations Director": FORM_TYPES.HR_OPERATIONS,
  "Photographer": FORM_TYPES.VIDEO_PHOTO,
  "Photographer - Jewelry and Product": FORM_TYPES.VIDEO_PHOTO,
  "Photographer - Senior": FORM_TYPES.VIDEO_PHOTO,
  "Post Production Producer": FORM_TYPES.POST_PRODUCTION,
  "Producer": FORM_TYPES.PRODUCTION,
  "Producer - Senior": FORM_TYPES.PRODUCTION,
  "Product Designer": FORM_TYPES.CREATIVE,
  "Product Manager": FORM_TYPES.TECH_LEADERSHIP,
  "Production Assistant": FORM_TYPES.PRODUCTION,
  "Production Manager": FORM_TYPES.PRODUCTION,
  "Production Manager - Senior": FORM_TYPES.PRODUCTION,
  "Public Relations Director": FORM_TYPES.DIGITAL,
  "Public Relations Manager": FORM_TYPES.DIGITAL,
  "QA Engineer": FORM_TYPES.TECH,
  "Retoucher - Beauty and Fashion": FORM_TYPES.POST_PRODUCTION,
  "Retoucher - Jewellery and Products": FORM_TYPES.POST_PRODUCTION,
  "SEO Director": FORM_TYPES.DIGITAL,
  "SEO Manager": FORM_TYPES.DIGITAL,
  "SEO Manager - Senior": FORM_TYPES.DIGITAL,
  "SEO Specialist": FORM_TYPES.DIGITAL,
  "Set Designer": FORM_TYPES.PRODUCTION,
  "Social Media Account Director": FORM_TYPES.SOCIAL_MEDIA,
  "Social Media Account Executive": FORM_TYPES.SOCIAL_MEDIA,
  "Social Media Account Manager": FORM_TYPES.SOCIAL_MEDIA,
  "Social Media Account Manager - Senior": FORM_TYPES.SOCIAL_MEDIA,
  "Social Media Strategist": FORM_TYPES.SOCIAL_MEDIA,
  "Software Engineering Manager": FORM_TYPES.TECH_LEADERSHIP,
  "Studio Runner": FORM_TYPES.PRODUCTION,
  "Stylist - Wardrobe": FORM_TYPES.PRODUCTION,
  "Talent Acquisition Manager": FORM_TYPES.HR_OPERATIONS,
  "Talent Acquisition Manager - baguette": FORM_TYPES.HR_OPERATIONS,
  "Talent Acquisition Specialist": FORM_TYPES.HR_OPERATIONS,
  "Talent Acquisition Specialist - Junior": FORM_TYPES.HR_OPERATIONS,
  "Talent Acquisition Specialist - Senior": FORM_TYPES.HR_OPERATIONS,
  "Technical Project Manager": FORM_TYPES.TECH_LEADERSHIP,
  "Technical Team Lead": FORM_TYPES.TECH_LEADERSHIP,
  "Telesales Specialist": FORM_TYPES.ACCOUNT_MANAGEMENT,
  "Traffic Manager": FORM_TYPES.HR_OPERATIONS,
  "UX/UI - Researcher": FORM_TYPES.TECH,
  "UX/UI Designer": FORM_TYPES.TECH,
  "UX/UI Designer - Junior": FORM_TYPES.TECH,
  "UX/UI Designer - Senior": FORM_TYPES.TECH,
  "VFX Artist": FORM_TYPES.POST_PRODUCTION,
  "VFX Artist - Junior": FORM_TYPES.POST_PRODUCTION,
  "VFX Artist - Senior": FORM_TYPES.POST_PRODUCTION,
  "Videographer": FORM_TYPES.VIDEO_PHOTO,
  "Videographer - Junior": FORM_TYPES.VIDEO_PHOTO,
  "Videographer - Senior": FORM_TYPES.VIDEO_PHOTO,
  "Videographer/Editor": FORM_TYPES.VIDEO_PHOTO,
  "Videographer/Editor - Junior": FORM_TYPES.VIDEO_PHOTO,
  "Videographer/Editor - Senior": FORM_TYPES.VIDEO_PHOTO
};

/**
 * Get form type for a given position
 * @param {string} position - Position name
 * @returns {string|null} Form type constant or null if not found
 */
export function getFormTypeForPosition(position) {
  return POSITION_FORM_MAPPING[position] || null;
}

/**
 * Get Airtable page ID for a given position
 * @param {string} position - Position name
 * @returns {string|null} Airtable page ID or null if not found
 */
export function getPageIdForPosition(position) {
  const formType = getFormTypeForPosition(position);
  return formType ? FORM_TYPE_TO_PAGE_ID[formType] : null;
}

/**
 * Get all positions for a given form type
 * @param {string} formType - Form type constant
 * @returns {string[]} Array of position names
 */
export function getPositionsForFormType(formType) {
  return Object.entries(POSITION_FORM_MAPPING)
    .filter(([_, type]) => type === formType)
    .map(([position]) => position);
}

/**
 * Get form type display name
 * @param {string} formType - Form type constant
 * @returns {string} Human-readable form type name
 */
export function getFormTypeDisplayName(formType) {
  const displayNames = {
    [FORM_TYPES.TECH]: 'Technology',
    [FORM_TYPES.TECH_LEADERSHIP]: 'Technology Leadership',
    [FORM_TYPES.CREATIVE]: 'Creative',
    [FORM_TYPES.VIDEO_PHOTO]: 'Video & Photography',
    [FORM_TYPES.POST_PRODUCTION]: 'Post Production',
    [FORM_TYPES.SOCIAL_MEDIA]: 'Social Media',
    [FORM_TYPES.ACCOUNT_MANAGEMENT]: 'Account Management',
    [FORM_TYPES.PRODUCTION]: 'Production',
    [FORM_TYPES.HR_OPERATIONS]: 'HR & Operations',
    [FORM_TYPES.DIGITAL]: 'Digital Marketing',
    [FORM_TYPES.FINANCE]: 'Finance'
  };
  return displayNames[formType] || formType;
}

export default POSITION_FORM_MAPPING;
